var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloudCoginline = function SvgCloudCoginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.008,
    cy: 22,
    r: 22,
    fill: "#7D64FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.442 15.075a7.502 7.502 0 0 0-1.167 14.587l.475-2.373a5.103 5.103 0 0 1 1.03-9.838l1.512-.215.446-1.46a7.604 7.604 0 0 1 14.54 0l.446 1.46 1.511.215a5.102 5.102 0 0 1 1.03 9.838l.475 2.373a7.503 7.503 0 0 0-1.167-14.587C30.323 10.98 26.513 8 22.008 8s-8.315 2.98-9.566 7.075Zm15.606 13.018 1.85 1.344c.054.04.091.096.104.16a.257.257 0 0 1-.032.186l-1.467 2.435a.277.277 0 0 1-.152.12.29.29 0 0 1-.197-.008l-2.143-.867c-.58.48-1.249.85-1.971 1.096l-.288 2.207a.263.263 0 0 1-.092.167.285.285 0 0 1-.184.067H20.54a.285.285 0 0 1-.184-.067.263.263 0 0 1-.092-.167l-.288-2.207a6.25 6.25 0 0 1-1.973-1.096l-2.142.868a.29.29 0 0 1-.197.007.276.276 0 0 1-.153-.12l-1.467-2.435a.257.257 0 0 1 .073-.347l1.852-1.343a5.626 5.626 0 0 1 0-2.186l-1.852-1.343a.257.257 0 0 1-.073-.347l1.468-2.435a.276.276 0 0 1 .153-.12.29.29 0 0 1 .197.008l2.142.867c.58-.48 1.25-.85 1.972-1.096l.288-2.207a.263.263 0 0 1 .092-.167.285.285 0 0 1 .184-.067h2.935c.067 0 .133.024.184.067.05.043.083.102.092.167l.288 2.207c.722.245 1.39.617 1.971 1.097l2.143-.868a.29.29 0 0 1 .197-.007c.064.02.118.063.152.12l1.467 2.434a.257.257 0 0 1 .032.186.266.266 0 0 1-.105.16l-1.85 1.344c.07.36.107.726.108 1.093 0 .367-.036.733-.107 1.093Zm-7.74 1.346a3.157 3.157 0 0 0 1.7.494 3.13 3.13 0 0 0 2.165-.859c.574-.55.896-1.296.896-2.074 0-.58-.18-1.147-.516-1.63a3.036 3.036 0 0 0-1.373-1.08 3.184 3.184 0 0 0-1.769-.167 3.105 3.105 0 0 0-1.567.803c-.428.41-.72.933-.838 1.502a2.82 2.82 0 0 0 .174 1.694c.232.537.624.995 1.128 1.317Z",
    fill: "url(#cloud-cog_inline_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloud-cog_inline_svg__a",
    x1: 22.011,
    y1: 13.532,
    x2: 22.011,
    y2: 37.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#fff",
    stopOpacity: 0.8
  })))));
};
export default SvgCloudCoginline;